<template>
  <div class="page">
    <pcHeaders></pcHeaders>
    <div style="min-height: 80vh">
      <div class="nav"></div>
      <div class="group_1">
        <div class="box_1">
          <div class="back">
            <div class="icon_1" @click="back"><img src="../../assets/images/Frame@2x (1).png" alt="" /></div>
            <div class="text_1" @click="back">返回列表</div>
          </div>
          <div class="content">
            <div class="info">
              <div class="avater">
                <img :src="detail.photo" alt="" v-if="detail.photo != '' && detail.photo != null" />
                <img src="../../assets/images/avater.png" alt="" v-else />
              </div>
              <div>
                <div class="text_2">{{ detail.realname || '' }}</div>
                <div class="text_3">{{ detail.position || '' }}</div>
              </div>
            </div>
            <div class="desc" v-if="detail.memo != '' && detail.memo != null">
              {{ detail.memo }}
            </div>
            <div class="desc" v-else>暂无介绍</div>
            <div class="group_3">
              <div v-for="(item, index) in qualificationCert" :key="index" class="cert">
                <img :src="item" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '.././component/head.vue';
import pcBottom from '.././component/bottom.vue';
import { getSysTeacherDetail } from '@/api/study';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom
  },
  data() {
    // 这里存放数据
    return {
      id: '',
      detail: {},
      qualificationCert: []
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //返回首页
    back() {
      this.$router.replace('/tearchList');
    },
    getInfo() {
      getSysTeacherDetail({ id: this.id }).then(res => {
        this.detail = res.data.data;
        this.qualificationCert = res.data.data.qualificationCert ? res.data.data.qualificationCert.split(',').map(item => item.trim()) : [];
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.getInfo();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background: #f4f6fa;
}
.nav {
  width: 100%;
  height: 250px;
  background-image: url('../../assets/images/Group 2595@2x.png');
  background-size: 100%;
}
.group_1 {
  display: flex;
  justify-content: center;
  width: 100%;
  height: auto;
  .box_1 {
    background: #ffffff;
    width: 1400px;
    height: auto;
    padding: 40px;
  }
  .back {
    display: flex;
    align-items: center;
    height: 22px;
    img {
      width: 16px;
      height: 16px;
    }
    .icon_1 {
      width: 16px;
      height: 16px;
    cursor: pointer;

    }
    .text_1 {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      margin-left: 7px;
    cursor: pointer;
      
    }
  }
  .content {
    width: 100%;
    margin-top: 17px;
    .list:nth-child(6n) {
      margin-right: 0 !important;
    }
    .info {
      margin-top: 28px;
      display: flex;
      .text_2 {
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
      }
      .text_3 {
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: rgba(51, 51, 51, 0.5);
        margin-top: 2px;
      }
      .avater {
        width: 48px;
        height: 48px;
        margin-right: 20px;

        img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
        }
      }
    }
  }
}
.desc {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
  margin-top: 20px;
}
.group_3 {
  margin-top: 23px;
  display: flex;
  flex-wrap: wrap;
  .cert:nth-child(4n) {
    margin-right: 0 !important;
  }
  .cert {
    margin-bottom: 20px;
    margin-right: 20px;
    width: 300px;
    height: auto;
    border-radius: 0px 0px 0px 0px;
    img {
      width: 300px;
      height: auto;
      border-radius: 0px 0px 0px 0px;
    }
  }
}
</style>
